// tslint:disable:ordered-imports
import {
  Component,
  Inject,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from "@angular/core";
import { MD_DIALOG_DATA, MdDialog } from "@angular/material";
import { Rule } from "../../models/rule";
import { MagicBoxService } from "../../services/magic-box.service";
import { Value } from "../../models/value";
import { ValueChapca } from "../../models/ValueChapca";
import { RuleReferences } from "../../models/ruleReferences";
import { TinymceEditorComponent } from "../../components/tinymce-editor/tinymce-editor.component";
import { Store } from "@ngrx/store";
import { ListSelectorComponent } from "../../components/list-selector/list-selector.component";
import { RulesActions } from "../../store/actions/rules.actions";
import { AdminService } from "../../services/admin.service";
import { PictureCropperComponent } from "../../components/picture-cropper/picture-cropper.component";
import { PictureService } from "../../services/picture.service";
import { User } from "../../models/user";
import { Subscription } from "rxjs/Subscription";
import { FiltersService } from "../../services/filters.service";
import { Observable } from "rxjs/Observable";
import { SuccessComponent } from "../success/success.component";
import { RuleDuplicateWarningComponent } from "../rule-duplicate-warning/rule-duplicate-warning.component";
import { RulesService } from "../../services/rules.service";
import { NgModel } from "@angular/forms";
import { ReferentialService } from "../../services/referential.service";
import { ProgramArticlePictureETTValue } from "../../models/program-article-translation-value";
import * as _ from "lodash";
import { Language } from "../../models/language";

@Component({
  selector: "app-magic-box-rule-form",
  templateUrl: "./magic-box-rule-form.component.html",
  styleUrls: ["./magic-box-rule-form.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MagicBoxRuleFormComponent {
  title: string;
  rule: Rule;
  ifMode: boolean;
  items: RuleReferences[];
  loading: boolean;
  loadingImage: boolean;
  possibilities: number;
  referentialTypes: Value[];
  filteredReferentialTypes: Value[];
  filters: any;
  destinations: Value[];
  fields: Value[];
  filteredFields: Value[];
  editMode: boolean;
  viewMode: boolean;
  pictures: ProgramArticlePictureETTValue[];
  errorMessage: string;
  newOriginal: string;
  equinoxeTerm: string;
  currentUser: User;
  subscriptions: Subscription[];
  randomEntities: any;
  showEndDate: boolean;
  canArray: string[];
  canViewArray: string[];
  isNonSportiveClassif: boolean;
  type: Value;
  channelGroups: ValueChapca[];
  isFieldPicture: boolean;
  isFieldPromo: boolean;

  @ViewChild("tinymce") tinymce: TinymceEditorComponent;
  @ViewChildren("selector") selectors: QueryList<ListSelectorComponent>;
  @ViewChild("cropper169") cropper169: PictureCropperComponent;
  @ViewChild("cropper43") cropper43: PictureCropperComponent;
  @ViewChild("cropper34") cropper34: PictureCropperComponent;
  @ViewChild("cropper715") cropper715: PictureCropperComponent;
  @ViewChild("cropper103") cropper103: PictureCropperComponent;
  @ViewChild("cropper11") cropper11: PictureCropperComponent;
  @ViewChild("cropper23") cropper23: PictureCropperComponent;
  @ViewChild("cropper31") cropper31: PictureCropperComponent;
  @ViewChild("cropper140303") cropper140303: PictureCropperComponent;
  @ViewChild("cropper485173") cropper485173: PictureCropperComponent;

  /**
   * Initialize variables and load data from API and store
   * @param data
   * @param {MagicBoxService} magicBoxService
   * @param {ReferentialService} ReferentialService
   * @param {AdminService} adminService
   * @param {RulesActions} rulesActions
   * @param {PictureService} pictureService
   * @param {Store<any>} store
   * @param {FiltersService} filtersService
   * @param {RulesService} rulesService
   * @param {MdDialog} mdDialog
   */
  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    private magicBoxService: MagicBoxService,
    private ReferentialService: ReferentialService,
    private adminService: AdminService,
    private rulesActions: RulesActions,
    private pictureService: PictureService,
    private store: Store<any>,
    private filtersService: FiltersService,
    private rulesService: RulesService,
    private mdDialog: MdDialog
  ) {
    this.setTitle();
    this.loading = true;
    this.canArray = [];
    this.canViewArray = [];
    this.destinations = [];
    this.channelGroups = [];
    this.subscriptions = [];
    this.isNonSportiveClassif = false;
    this.items = [];
    this.isFieldPicture = true;
    this.isFieldPromo = false;

    this.pictures = [];
    this.initPictures();
    /**
     * Get rights from admin service
     */
    this.adminService.init().subscribe(() => {
      if (this.adminService.can("Magic Box Digital", "Edit")) {
        this.canArray.push("Digital");
      }
      if (this.adminService.can("Magic Box Press", "Edit")) {
        this.canArray.push("Press");
      }
      if (this.adminService.can("Magic Box Popup Next", "Edit")) {
        this.canArray.push("Popup Next");
      }
      if (this.adminService.can("Magic Box Partners", "Edit")) {
        this.canArray.push("Partners");
      }

      if (this.adminService.can("Magic Box Digital", "View")) {
        this.canViewArray.push("Digital");
      }
      if (this.adminService.can("Magic Box Press", "View")) {
        this.canViewArray.push("Press");
      }
      if (this.adminService.can("Magic Box Popup Next", "View")) {
        this.canViewArray.push("Popup Next");
      }
      if (this.adminService.can("Magic Box Partners", "View")) {
        this.canViewArray.push("Partners");
      }

      /**
       * Get referential type, current user and create the rule
       */
      this.getReferentialTypes().subscribe(() => {
        this.getUserState();
        this.createRule();
        this.filteredReferentialTypes = this.referentialTypes.filter(
          (t) => t.value !== "ChannelGroup"
        );
      });

      /**
       * Get ChannelGroup
       */
      this.ReferentialService.getChannelGroup().subscribe((res) => {
        this.channelGroups = res;
      });

      /**
       * Get destinations and fields
       */
      let tempDestinations = JSON.parse(
        localStorage.getItem("destinations")
      ).filter((destination) => destination.id != "AllDestinations");

      tempDestinations.forEach((dest) => {
        if (this.canArray.includes("Digital") && dest.value === "Digital") {
          this.destinations.push(dest);
        }
        if (this.canArray.includes("Press") && dest.value === "Press") {
          this.destinations.push(dest);
        }
        if (
          this.canArray.includes("Popup Next") &&
          dest.value === "Popup Next"
        ) {
          this.destinations.push(dest);
        }
        if (this.canArray.includes("Partners") && dest.value === "Partners") {
          this.destinations.push(dest);
        }
      });

      this.magicBoxService.getFields().subscribe((fields) => {
        this.filteredFields = fields.filter((t) => t.value !== "Picture");
      });
    });
  }

  /**
   * Create the rule, empty if without params ID else get the data from the API
   */
  createRule() {
    if (this.data.id && this.data.id !== undefined) {
      this.magicBoxService
        .getById(this.data.id, this.data.optional2)
        .subscribe((rule) => {
          this.editMode =
            this.canArray.indexOf(rule.destination["value"]) !== -1;
          this.viewMode =
            this.canViewArray.indexOf(rule.destination["value"]) !== -1;
          if (rule.type || rule.group || rule.label) {
            this.isNonSportiveClassif = true;
            this.magicBoxService
              .getReferentialTypes(this.isNonSportiveClassif)
              .subscribe((types) => {
                this.referentialTypes = types;
              });
          }
          if (this.data.optional && this.data.optional === "duplicate") {
            rule.id = null;
          }
          if (rule.for === 4) {
            if (rule.pictures) {
              this.pictures = rule.pictures;
            } else {
              this.initPictures();
            }
          }
          if (rule.for !== 4) {
            rule.wysiwyg = this.translateNativeRule(rule.value);
          }
          this.init(rule);
        });
    } else {
      let rule = new Rule({
        languageId: this.currentUser.currentLanguage.id,
        value: "",
        channelGroupid: 0,
      });

      // reset filters referential
      this.filtersService.selectedReferentialEntities = [];

      this.editMode = this.canArray.length > 0;
      this.viewMode = this.canViewArray.length > 0;
      if (this.magicBoxService.creationRuleFilters) {
        rule = this.setRuleFromFilters(rule);
        rule = this.setSelectorValueToRuleByFilters(rule);
        if (!rule.for) {
          rule.for = 1;
        }
      }
      this.init(rule);
    }
  }

  /**
   * Initialize the rule and load the random entities (for examples list)
   * @param {Rule} rule
   */
  init(rule: Rule) {
    this.rule = rule;
    if (!this.rule.id) {
      this.rule.languages = [];
      this.rule.languages.push(this.currentUser.currentLanguage.id);
    }
    this.ifMode = false;
    if (rule.for !== 4 && (this.editMode || this.viewMode)) {
      this.getRandomEntities(this.rule).subscribe(() => {
        this.rule.overview = this.generateOverview(this.rule);
        this.rule.overviewShort = this.generateOverviewShortTag(this.rule);

        this.changeTypeClassification({ checked: this.isNonSportiveClassif });
        this.magicBoxService
          .getRulesReferences(this.isNonSportiveClassif)
          .subscribe((items) => {
            this.items = items;
            this.loading = false;
          });
      });
    } else {
      this.loading = false;
    }
  }

  /**
   * Get current user from the store
   */
  getUserState() {
    this.subscriptions.push(
      this.store.select("userState").subscribe((user: User) => {
        this.currentUser = user ? user : null;
      })
    );
  }

  /**
   * Get referential types from the API
   * @returns {Observable<any>}
   */
  getReferentialTypes() {
    return new Observable((observer) => {
      this.magicBoxService
        .getReferentialTypes(this.isNonSportiveClassif)
        .subscribe((types) => {
          this.referentialTypes = types;
          observer.next();
        });
    });
  }

  /**
   * Toggle if mode with the button "IF"
   */
  toggleIfMode() {
    this.ifMode = !this.ifMode;
  }

  /**
   * When an item is clicked, add the block (item or condition)
   * @param item
   */
  itemClicked(item) {
    item = item.toLowerCase();
    const className =
      this.tinymce.editor.selection.getNode().parentElement.className;
    if (className === "rule mceNonEditable") {
      return;
    }
    if (this.ifMode) {
      const timestamp = Date.now();
      const content =
        '<span class="rule mceNonEditable"><span class="cond"><span class="if">if</span>' +
        item +
        '</span><span id="' +
        timestamp +
        '" class="then mceEditable"></span></span>';
      this.tinymce.editor.insertContent(content);
      const node = this.tinymce.editor.dom.select("#" + timestamp);
      this.tinymce.editor.selection.setCursorLocation(node[0]);
      this.ifMode = false;
    } else {
      this.tinymce.editor.insertContent(
        '<span class="item mceNonEditable">' + item + "</span>"
      );
    }
  }

  /**
   * Convert tiny MCE value to raw rule
   * @param event
   */
  createNativeRule(event) {
    // Remove if label
    const ifRegex = new RegExp('<span class="if">if</span>', "gi");
    event = event.replace(ifRegex, "");
    // Get text to display
    const displayRegex = new RegExp(
      '<span id="[0-9]*" class="then mceEditable">(.*?)<\\/span>',
      "gi"
    );
    event = event.replace(displayRegex, ",$1");
    // Get condition
    const conditionRegex = new RegExp(
      '<span class="cond">(.*?)<\\/span>',
      "gi"
    );
    event = event.replace(conditionRegex, "$1");
    // IfTag
    const ifTagRegex = new RegExp(
      '<span class="rule mceNonEditable">(.*?)<\\/span>',
      "gi"
    );
    event = event.replace(ifTagRegex, "%if $1%");
    // ItemTag
    const itemTagRegex = new RegExp(
      '<span class="item mceNonEditable">(.*?)</span>',
      "gi"
    );
    event = event.replace(itemTagRegex, "%$1%");

    //&nbsp;
    const spaceRegex = new RegExp("&nbsp;", "gi");
    event = event.replace(spaceRegex, " ");

    //&amp;
    const andRegex = new RegExp("&amp;", "gi");
    event = event.replace(andRegex, "&");

    this.rule.value = event;
    this.rule.overview = this.generateOverview(this.rule);
    this.rule.overviewShort = this.generateOverviewShortTag(this.rule);
  }

  /**
   * Convert raw rule to tinyMCE html
   * @param {string} rule
   * @returns {string}
   */
  translateNativeRule(rule: string) {
    const timestamp = Date.now();

    const ifRegex = new RegExp("%if (.*?),(.*?)%", "gi");
    rule = rule.replace(
      ifRegex,
      '<span class="rule mceNonEditable"><span class="cond"><span class="if">if</span>$1</span><span id="' +
        timestamp +
        '" class="then mceEditable">$2</span></span>'
    );

    const itemRegex = new RegExp("%([a-zA-Z0-9_]*)%", "gi");
    rule = rule.replace(
      itemRegex,
      '<span class="item mceNonEditable">$1</span>'
    );

    return rule;
  }

  /**
   * Generate all the combinations for the rule with the random entities
   * @param {Rule} rule
   * @returns {any[]}
   */
  generateOverview(rule: Rule) {
    const ifRegex = new RegExp("%if (.*?),(.*?)%", "gi");
    let overview = [];
    const matches = rule.value.match(ifRegex);
    if (matches && matches.length > 0) {
      this.possibilities = Math.pow(2, matches.length);
      const combinations = [];
      for (let i = 0; i < this.possibilities; i++) {
        combinations.push(this.binaryToArray(i.toString(2), matches.length));
      }
      combinations.forEach((combination) => {
        let rulePossibility = rule.value;
        let index = 0;
        const itemToDelete = [];
        rulePossibility = rulePossibility.replace(ifRegex, (match, p1) => {
          if (combination[index++]) {
            return match;
          } else {
            itemToDelete.push(p1);
            return "";
          }
        });
        itemToDelete.forEach((item) => {
          rulePossibility = rulePossibility.replace("%" + item + "%", "");
        });
        overview.push(this.fillOverview(rulePossibility));
      });
    } else {
      this.possibilities = 1;
      overview = [this.fillOverview(rule.value)];
    }
    return overview;
  }

  /**
   * Generate all the combinations for the rule with the random entities Short Tag
   * @param {Rule} rule
   * @returns {any[]}
   */
  generateOverviewShortTag(rule: Rule) {
    const ifRegex = new RegExp("%if (.*?),(.*?)%", "gi");
    let overviewShort = [];
    const matches = rule.value.match(ifRegex);
    if (matches && matches.length > 0) {
      this.possibilities = Math.pow(2, matches.length);
      const combinations = [];
      for (let i = 0; i < this.possibilities; i++) {
        combinations.push(this.binaryToArray(i.toString(2), matches.length));
      }
      combinations.forEach((combination) => {
        let rulePossibility = rule.value;
        let index = 0;
        const itemToDelete = [];
        rulePossibility = rulePossibility.replace(ifRegex, (match, p1) => {
          if (combination[index++]) {
            return match;
          } else {
            itemToDelete.push(p1);
            return "";
          }
        });
        itemToDelete.forEach((item) => {
          rulePossibility = rulePossibility.replace("%" + item + "%", "");
        });
        overviewShort.push(this.fillOverviewShortTag(rulePossibility));
      });
    } else {
      this.possibilities = 1;
      overviewShort = [this.fillOverviewShortTag(rule.value)];
    }
    return overviewShort;
  }

  /**
   * Convert a binary number to an array
   * @param {string} binary
   * @param {number} width
   * @returns {any[]}
   */
  binaryToArray(binary: string, width: number) {
    const array = [];
    while (binary.length < width) {
      binary = "0" + binary;
    }
    for (let j = 0; j < width; j++) {
      array[j] = binary[j] === "1";
    }
    return array;
  }

  /**
   * Replace block with random entities values
   * @param {string} overview
   * @returns {string}
   */
  fillOverview(overview: string) {
    const ifRegex = new RegExp("%if (.*?),(.*?)%", "gi");
    overview = overview.replace(ifRegex, "$2");

    const itemRegex = new RegExp("%([a-zA-Z0-9_]*)%", "gi");
    overview = overview.replace(itemRegex, (match, p1) => {
      if (this.randomEntities && this.randomEntities[p1]) {
        return this.randomEntities[p1];
      } else {
        return p1;
      }
    });

    return overview;
  }

  /**
   * Replace block with random entities Short values
   * @param {string} overviewShort
   * @returns {string}
   */
  fillOverviewShortTag(overviewShort: string) {
    const ifRegex = new RegExp("%if (.*?),(.*?)%", "gi");
    overviewShort = overviewShort.replace(ifRegex, "$2");

    const itemRegex = new RegExp("%([a-zA-Z0-9_]*)%", "gi");
    overviewShort = overviewShort.replace(itemRegex, (match, p1) => {
      if (this.randomEntities && this.randomEntities[p1 + "Short"]) {
        return this.randomEntities[p1 + "Short"];
      } else {
        return p1;
      }
    });

    return overviewShort;
  }

  /**
   * Delete rule with an API call
   */
  deleteRule() {
    this.magicBoxService.preDelete(this.rule).subscribe((res) => {
      if (res.success && res.success === 2) {
        this.loading = false;
        this.mdDialog.open(RuleDuplicateWarningComponent, {
          data: {
            message: res.message,
            values: res.values,
            rule: this.rule,
            mode: "delete",
          },
        });
      }
    });
  }

  /**
   * Define the modal tital according to the action and the ID parameter
   */
  setTitle() {
    if (!this.data.id) {
      this.title = "Create rule";
    } else {
      this.title =
        this.data.optional && this.data.optional === "duplicate"
          ? "Duplicate rule #" + this.data.id
          : "Edit rule #" + this.data.id;
    }
  }

  /**
   * Assign to the selectors their values from the rule data
   * @param type
   * @returns {any}
   */
  getFiltersSelectorValue(type) {
    const valueName = type.value.toLowerCase();
    if (this.data.id) {
      if (this.rule[valueName]) {
        return [this.rule[valueName]];
      }
    } else if (this.filters && this.filters[type.value]) {
      return this.filters[type.value];
    }
    return [];
  }

  /**
   * Initialize the rule with the filters parameters
   * @param {Rule} rule
   * @returns {Rule}
   */
  setRuleFromFilters(rule: Rule) {
    this.filters = this.magicBoxService.creationRuleFilters;
    this.magicBoxService.creationRuleFilters = null;
    this.isNonSportiveClassif = this.filters.isNonSportiveClassif;
    rule.for = this.filters.for;
    rule.applyTo = [];
    this.filters.applyTo.forEach((dest) => {
      if (this.canArray.includes("Digital") && dest === "Digital") {
        rule.applyTo.push(dest);
      }
      if (this.canArray.includes("Press") && dest === "Press") {
        rule.applyTo.push(dest);
      }
      if (this.canArray.includes("Popup Next") && dest === "Popup Next") {
        rule.applyTo.push(dest);
      }
      if (this.canArray.includes("Partners") && dest === "Partners") {
        rule.applyTo.push(dest);
      }
    });

    return rule;
  }

  /**
   * Duplicate rule when button "duplicate" is clicked
   */
  duplicate() {
    this.title = "Duplicate rule #" + this.data.id;
    this.rule.id = null;
  }

  /**
   * Save rule
   */
  save() {
    this.loading = true;
    /**
     * If it's a picture rule, process picture
     */
    if (this.rule.for === 4) {
      this.processPicture();

      // for duplicate, processPicture change this.pictures to empty list
      if (this.pictures.length > 0) {
        this.rule.pictures = this.pictures;
      }
    }
    /**
     * Get selectors value and assign it to the rule
     */
    this.selectors.forEach((selector) => {
      this.rule[selector.type.value] = selector.selectedValues[0];
      this.rule[selector.type.value.toLowerCase()] = selector.selectedValues[0];
    });

    /**
     * If the rule have an id, update the rule
     */
    if (this.rule.id) {
      this.rule.updatedBy = this.currentUser.id;
      this.magicBoxService.updateRule(this.rule).subscribe((res) => {
        if (res.success && res.success === 2) {
          this.loading = false;
          this.mdDialog.open(RuleDuplicateWarningComponent, {
            data: {
              message: res.message,
              values: res.values,
              rule: this.rule,
              mode: "update",
            },
          });
        } else {
          this.rulesActions.updateRule(this.rule);
          this.rulesService.rulesUpdated.emit(true);
          this.mdDialog.closeAll();
          this.mdDialog.open(SuccessComponent, {
            data: { message: "Rule has been updated" },
          });
        }
      });
    } else {
      /**
       * Else create the rule
       */
      this.rule.createdBy = this.currentUser.id;
      this.magicBoxService.createRule(this.rule).subscribe((res) => {
        if (res.success && res.success === 2) {
          this.loading = false;
          this.mdDialog.closeAll();
          this.mdDialog.open(RuleDuplicateWarningComponent, {
            data: { message: res.message, values: res.values },
          });
        } else {
          this.rulesService.rulesUpdated.emit(true);
          this.mdDialog.closeAll();
          this.mdDialog.open(SuccessComponent, {
            data: { message: res.message },
          });
        }
      });
    }
  }

  /**
   * Get the field by id
   * @param {number} forId
   * @returns {Value | undefined}
   */
  getFieldById(forId: number) {
    return this.fields.find((field) => field.id === forId);
  }

  /**
   * Simulate a click on the upload input when picture is clicked or button upload
   */
  // noinspection JSMethodCanBeStatic
  upload() {
    document.getElementById("file_upload_cropper").click();
  }

  /**
   * Handler the drop of picture
   */
  onDrop(event) {
    event.preventDefault();
    this.fileChange(event);
  }

  /**
   * Handler needed to activate the OnDrop Handler
   */
  onDragOver(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  /**
   * When a file is uploaded, load the data and check the size according to the minimal required size
   * @param event
   */
  fileChange(event) {
    if (
      (event.target.files && event.target.files[0]) ||
      (event.dataTransfer.files && event.dataTransfer.files[0])
    ) {
      this.loadingImage = true;
      const file = event.target.files
        ? event.target.files[0]
        : event.dataTransfer.files[0];
      const reader = new FileReader();

      reader.addEventListener("load", () => {
        const image = new Image();
        image.src = reader.result as string;
        image.addEventListener("load", () => {
          if (image.width < 1920 && image.height < 1080) {
            this.errorMessage =
              "Image too small, it must be at least 1920x1080 px";
            setTimeout(() => (this.errorMessage = null), 5000);
          }
          this.changePicturesUrl(reader.result);
          this.newOriginal = reader.result as string;
          this.loading = false;
        });
      });

      reader.readAsDataURL(file);
    }
  }

  /**
   * Format the json picture data
   */
  processPicture() {
    let pictures = _.cloneDeep(this.pictures);
    this.pictures = [];
    if (this.newOriginal) {
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: null,
          blob: this.newOriginal,
          pictureFormatCode: "Original",
          pictureFormatName: "Original",
        })
      );
    } else {
      this.pictures.push(
        pictures.find((p) => p.pictureFormatCode === "Original")
      );
    }

    if (this.cropper169.edition) {
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: null,
          blob: this.cropper169.image,
          pictureFormatCode: "16:9",
          pictureFormatName: "16:9",
        })
      );
    } else {
      this.pictures.push(pictures.find((p) => p.pictureFormatCode === "16:9"));
    }

    if (this.cropper43.edition) {
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: null,
          blob: this.cropper43.image,
          pictureFormatCode: "4:3",
          pictureFormatName: "4:3",
        })
      );
    } else {
      this.pictures.push(pictures.find((p) => p.pictureFormatCode === "4:3"));
    }

    if (this.cropper34.edition) {
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: null,
          blob: this.cropper34.image,
          pictureFormatCode: "3:4",
          pictureFormatName: "3:4",
        })
      );
    } else {
      this.pictures.push(pictures.find((p) => p.pictureFormatCode === "3:4"));
    }

    if (this.cropper103.edition) {
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: null,
          blob: this.cropper103.image,
          pictureFormatCode: "10:3",
          pictureFormatName: "10:3",
        })
      );
    } else {
      this.pictures.push(pictures.find((p) => p.pictureFormatCode === "10:3"));
    }

    if (this.cropper11.edition) {
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: null,
          blob: this.cropper11.image,
          pictureFormatCode: "1:1",
          pictureFormatName: "1:1",
        })
      );
    } else {
      this.pictures.push(pictures.find((p) => p.pictureFormatCode === "1:1"));
    }

    if (this.cropper23.edition) {
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: null,
          blob: this.cropper23.image,
          pictureFormatCode: "2:3",
          pictureFormatName: "2:3",
        })
      );
    } else {
      this.pictures.push(pictures.find((p) => p.pictureFormatCode === "2:3"));
    }

    if (this.cropper140303.edition) {
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: null,
          blob: this.cropper140303.image,
          pictureFormatCode: "140:303",
          pictureFormatName: "140:303",
        })
      );
    } else {
      this.pictures.push(
        pictures.find((p) => p.pictureFormatCode === "140:303")
      );
    }

    if (this.cropper485173.edition) {
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: null,
          blob: this.cropper485173.image,
          pictureFormatCode: "485:173",
          pictureFormatName: "485:173",
        })
      );
    } else {
      this.pictures.push(
        pictures.find((p) => p.pictureFormatCode === "485:173")
      );
    }
  }

  /**
   * Get the equinoxe picture from an ID and transform the response to a valid image data
   */
  getEquinoxePicture() {
    if (
      !this.equinoxeTerm ||
      this.equinoxeTerm.length < 1 ||
      this.equinoxeTerm.length > 9
    ) {
      return;
    }
    this.loadingImage = true;
    this.pictureService.getPictureById(this.equinoxeTerm).subscribe((res) => {
      if (res.value && res.success === 1) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const image = new Image();
        image.crossOrigin = "Anonymous";
        image.src = res.value.original.url;
        image.addEventListener("load", () => {
          if (image.width >= 1920 && image.height >= 1080) {
            canvas.width = image.naturalWidth;
            canvas.height = image.naturalHeight;
            context.drawImage(image, 0, 0);
            const url = canvas.toDataURL("image/jpeg");
            this.errorMessage = null;
            this.changePicturesUrl(url);
            this.newOriginal = url;
            this.loadingImage = false;
          } else {
            this.errorMessage =
              "Image too small, it must be at least 1920x1080 px";
            setTimeout(() => (this.errorMessage = null), 5000);
            this.loadingImage = false;
          }
        });
      } else {
        if (res.message) {
          this.errorMessage = res.message;
          setTimeout(() => (this.errorMessage = null), 5000);
          this.loadingImage = false;
        }
        this.loadingImage = false;
      }
    });
  }

  /**
   * Fetch random entities from the API
   * @param {Rule} rule
   * @returns {Observable<any>}
   */
  getRandomEntities(rule: Rule) {
    return new Observable((observer) => {
      this.magicBoxService
        .getRandomReferentialEntities(rule)
        .subscribe((res) => {
          if (res && res.values) {
            this.randomEntities = res.values[0];
          }
          observer.next();
        });
    });
  }

  /**
   * When a selector change, update the random entities
   */
  selectorUpdated() {
    this.selectors.forEach((selector) => {
      this.rule[selector.type.value] = selector.selectedValues[0];
    });
    if (this.rule.for !== 4) {
      this.getRandomEntities(this.rule).subscribe(() => {
        this.rule.overview = this.generateOverview(this.rule);
        this.rule.overviewShort = this.generateOverviewShortTag(this.rule);
      });
    }
  }

  /**
   * Initialize the selectors with the filters data
   * @param {Rule} rule
   * @returns {Rule}
   */
  setSelectorValueToRuleByFilters(rule: Rule) {
    this.referentialTypes.forEach((type) => {
      if (this.filters[type.value] && this.filters[type.value].length > 0) {
        rule[type.value] = this.filters[type.value][0];
      }
    });
    return rule;
  }

  dateInit() {
    this.rule.startDate = new Date();
  }

  /**
   * If date change, check if start date is lower than end date
   */
  dateChange() {
    if (
      this.rule.startDate &&
      this.rule.endDate &&
      this.rule.startDate.getTime() > this.rule.endDate.getTime()
    ) {
      this.rule.endDate = this.rule.startDate;
    }
  }

  allLanguagesSelected() {
    return this.rule.languages.length === this.currentUser.languages.length;
  }

  selectAllLanguages(select: NgModel, values: Language[], event) {
    if (event.checked) {
      select.update.emit(values.map((v) => v.id));
    } else {
      select.update.emit([]);
    }
  }

  popupCountriesSelected() {
    return (
      this.rule.languages.filter(
        (v) =>
          v === 0 ||
          v === 1 ||
          v === 2 ||
          v === 3 ||
          v === 4 ||
          v === 5 ||
          v === 6 ||
          v === 14 ||
          v === 15 ||
          v === 16
      ).length === 10
    );
  }

  selectPopupCountries(select: NgModel, values: Language[], event) {
    if (event.checked) {
      select.update.emit(
        values
          .filter(
            (v) =>
              v.value === "INTERNATIONAL" ||
              v.value === "GERMAN" ||
              v.value === "ENGLISH" ||
              v.value === "FRENCH" ||
              v.value === "ITALIAN" ||
              v.value === "DUTCH" ||
              v.value === "SPANISH" ||
              v.value === "POLISH" ||
              v.value === "RUSSIAN" ||
              v.value === "ROMANIAN"
          )
          .map((v) => v.id)
      );
    } else {
      select.update.emit([]);
    }
  }

  resetDates() {
    this.rule.startDate = undefined;
    this.rule.endDate = undefined;
  }

  /**
   * @param {bool} editMode
   */
  canSave(editMode) {
    if (editMode) {
      return (
        ((this.rule.field.id === 4 &&
          this.pictures.find((p) => p.pictureFormatCode === "Original")) ||
          (this.rule.field.id !== 4 && this.rule.value)) &&
        (this.rule.destination.id > 0 ||
          this.rule.destination.value.length !== 0) &&
        this.rule.languages &&
        this.rule.languages.length > 0
      );
    } else {
      return (
        ((this.rule.for === 4 &&
          this.pictures.find((p) => p.pictureFormatCode === "Original")) ||
          (this.rule.for !== 4 && this.rule.value)) &&
        (this.rule.applyTo.length > 0 ||
          this.rule.destination.value.length !== 0) &&
        this.rule.languages &&
        this.rule.languages.length > 0
      );
    }
  }

  canDelete() {
    return (
      (this.rule.destination.id > 0 ||
        this.rule.destination.value.length !== 0) &&
      this.rule.languages &&
      this.rule.languages.length > 0
    );
  }

  /**
   * Change Between Sportive/NonSportive Classification and clear the selectors to avoid invalid data
   */
  changeTypeClassification(event) {
    this.isNonSportiveClassif = event.checked;
    this.selectors.forEach((selector) => selector.clearSelection());
    //Clear the rule selection section
    // tinymce does not exists for Magic Box Picture Rule
    if (this.tinymce) {
      this.tinymce.editor.setContent("");
    }
    this.rule.value = "";
    this.rule.overview = [];
    this.rule.overviewShort = [];
    this.magicBoxService
      .getReferentialTypes(this.isNonSportiveClassif)
      .subscribe((types) => {
        this.referentialTypes = types;
        this.filteredReferentialTypes = this.referentialTypes.filter(
          (t) => t.value !== "ChannelGroup"
        );
        types.forEach((type) => {
          if (this.filters[type.value]) {
            this.filtersService.addEntity(this.filters[type.value]);
          }
        });
      });
    this.magicBoxService
      .getRulesReferences(this.isNonSportiveClassif)
      .subscribe((items) => {
        this.items = items;
      });
  }

  selectChannelchange(args) {
    this.rule.channelGroupid = args.value;
  }

  getETTPictureByFormat(format: string) {
    if (this.pictures.find((p) => p.pictureFormatName === format)) {
      return this.pictures.find((p) => p.pictureFormatName === format);
    } else {
      return { pictureUrl: "" };
    }
  }

  changePicturesUrl(url: any) {
    if (this.pictures.find((p) => p.pictureFormatName === "Original")) {
      this.pictures.find((p) => p.pictureFormatName === "Original").pictureURL =
        url;
    }
    if (this.pictures.find((p) => p.pictureFormatName === "16:9")) {
      this.pictures.find((p) => p.pictureFormatName === "16:9").pictureURL =
        null;
    }
    if (this.pictures.find((p) => p.pictureFormatName === "3:4")) {
      this.pictures.find((p) => p.pictureFormatName === "3:4").pictureURL =
        null;
    }
    if (this.pictures.find((p) => p.pictureFormatName === "4:3")) {
      this.pictures.find((p) => p.pictureFormatName === "4:3").pictureURL =
        null;
    }
    if (this.pictures.find((p) => p.pictureFormatName === "10:3")) {
      this.pictures.find((p) => p.pictureFormatName === "10:3").pictureURL =
        null;
    }
    if (this.pictures.find((p) => p.pictureFormatName === "1:1")) {
      this.pictures.find((p) => p.pictureFormatName === "1:1").pictureURL =
        null;
    }
    if (this.pictures.find((p) => p.pictureFormatName === "2:3")) {
      this.pictures.find((p) => p.pictureFormatName === "2:3").pictureURL =
        null;
    }
    if (this.pictures.find((p) => p.pictureFormatName === "140:303")) {
      this.pictures.find((p) => p.pictureFormatName === "140:303").pictureURL =
        null;
    }
    if (this.pictures.find((p) => p.pictureFormatName === "485:173")) {
      this.pictures.find((p) => p.pictureFormatName === "485:173").pictureURL =
        null;
    }

    // hack to activate cropper on change of original picture
    if (this.cropper169) {
      this.cropper169.url = url;
      this.cropper169.src = null;
      this.cropper169.ngOnInit();
    }
    if (this.cropper34) {
      this.cropper34.url = url;
      this.cropper34.src = null;
      this.cropper34.ngOnInit();
    }
    if (this.cropper43) {
      this.cropper43.url = url;
      this.cropper43.src = null;
      this.cropper43.ngOnInit();
    }
    if (this.cropper103) {
      this.cropper103.url = url;
      this.cropper103.src = null;
      this.cropper103.ngOnInit();
    }
    if (this.cropper11) {
      this.cropper11.url = url;
      this.cropper11.src = null;
      this.cropper11.ngOnInit();
    }
    if (this.cropper23) {
      this.cropper23.url = url;
      this.cropper23.src = null;
      this.cropper23.ngOnInit();
    }
    if (this.cropper140303) {
      this.cropper140303.url = url;
      this.cropper140303.src = null;
      this.cropper140303.ngOnInit();
    }
    if (this.cropper485173) {
      this.cropper485173.url = url;
      this.cropper485173.src = null;
      this.cropper485173.ngOnInit();
    }
  }

  initPictures() {
    this.pictures.push(
      new ProgramArticlePictureETTValue({ pictureFormatCode: "Original" })
    );
    this.pictures.push(
      new ProgramArticlePictureETTValue({ pictureFormatCode: "16:9" })
    );
    this.pictures.push(
      new ProgramArticlePictureETTValue({ pictureFormatCode: "4:3" })
    );
    this.pictures.push(
      new ProgramArticlePictureETTValue({ pictureFormatCode: "3:4" })
    );
    this.pictures.push(
      new ProgramArticlePictureETTValue({ pictureFormatCode: "10:3" })
    );
    this.pictures.push(
      new ProgramArticlePictureETTValue({ pictureFormatCode: "1:1" })
    );
    this.pictures.push(
      new ProgramArticlePictureETTValue({ pictureFormatCode: "2:3" })
    );
    this.pictures.push(
      new ProgramArticlePictureETTValue({ pictureFormatCode: "140:303" })
    );
    this.pictures.push(
      new ProgramArticlePictureETTValue({ pictureFormatCode: "485:173" })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/magic-box-rule-form/magic-box-rule-form.component.ts